module.exports = __webpack_public_path__ + "static/media/totalDoacao.23047a85.svg";